const dressDetail1 = [
  { title: "A-Line", icon: "icon1", subcategories: [] },
  { title: "Midi", icon: "icon2", subcategories: [] },
  { title: "Long", icon: "icon2", subcategories: [] },
  { title: "Short", icon: "icon2", subcategories: [] },
  { title: "Hi-Low", icon: "icon2", subcategories: [] },
];

export default dressDetail1;
